import React from 'react';
import {Alert, Form, Icon, Input, Button, Row, Col, Select} from 'antd';
import get from 'lodash/get';
import { updateAccountInfoRequest } from '../../api/requests';

import classes from './MyProfileForm.css';

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const timeZones = {
  '': null,
  'America/Edmonton': 'MT',
  'America/Vancouver': 'PT',
  'America/Winnipeg': 'CT',
  'America/Toronto': 'ET',
  'America/Halifax': 'AT',
};

class MyProfileForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const profile = {...values};
          profile.short_tz = timeZones[profile.time_zone];
          if (profile.time_zone === "") {
            profile.time_zone = null;
          }

          if (!profile.phone_number) {
            delete profile['phone_number']
          }

          await updateAccountInfoRequest(profile);
          this.setState({ isLoading: false, requestResult: {type: 'success', message: 'Success' } });
          this.props.onSubmit();
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };


  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue, setFieldValue } = this.props.form;

        return (
          <div className={classes.wrapper}>
              <Form onSubmit={this.handleSubmit}>
                <h3 className='headline-default'>Edit profile</h3>

                <Row gutter={12}>
                  <Col>
                    <label>
                      <b>Email</b>
                      <Form.Item>
                        {getFieldDecorator('email', {
                          rules: [{ required: true, message: 'Required' }],
                          initialValue: get(this.props, 'email')
                        })( <Input type='email' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col>
                    <label>
                      <b>First name</b>
                      <Form.Item>
                        {getFieldDecorator('first_name', {
                          rules: [{ required: true, message: 'Required' }],
                          initialValue: get(this.props, 'first_name')
                        })( <Input type='text' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col>
                    <label>
                      <b>Last name</b>
                      <Form.Item>
                        {getFieldDecorator('last_name', {
                          rules: [{ required: true, message: 'Required' }],
                          initialValue: get(this.props, 'last_name')
                        })( <Input type='text' /> )}
                      </Form.Item>
                    </label>
                  </Col>

                  <Col>
                    <Alert message='Changing First and Last name will modify the randomization ID' type="warning" style={{ margin: '-15px 0 10px' }} />
                  </Col>
                  <Col>
                    <label>
                      <b>Phone number</b>
                      <Form.Item>
                        {getFieldDecorator('phone_number', {
                          initialValue: get(this.props, 'phone_number')
                        })( <Input type='phone' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                  <Col>
                  <label>
                    <b>Time Zone:</b>
                    <Form.Item>
                      {getFieldDecorator('time_zone', {
                        initialValue: get(this.props, 'time_zone', '')
                      })(
                        <Select placeholder='Select'>
                          <Option value="">None</Option>
                          <Option value="America/Edmonton">America/Edmonton</Option>
                          <Option value="America/Vancouver">America/Vancouver</Option>
                          <Option value="America/Winnipeg">America/Winnipeg</Option>
                          <Option value="America/Toronto">America/Toronto</Option>
                          <Option value="America/Halifax">America/Halifax</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                  </Col>
                  <Col>
                  <label>
                      <b>Short TZ</b>
                      <Form.Item>
                        {getFieldDecorator('short_tz', {
                          initialValue: timeZones[getFieldValue('time_zone')]
                        })( <Input disabled={true} type='text' /> )}
                      </Form.Item>
                    </label>
                 </Col>
                  <Col>
                    <label>
                      <b>Type your password to confirm the changes</b>
                      <Form.Item>
                        {getFieldDecorator('password', {
                          rules: [{ required: true, message: 'Required' }],
                          initialValue: get(this.props, 'password')
                        })( <Input type='password' /> )}
                      </Form.Item>
                    </label>
                  </Col>
                </Row>

                {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

                <Form.Item className={classes.actionWrapper}>
                  <Button type='primary' size='large' htmlType='submit'>
                    Save
                    {isLoading && <Icon type='loading' />}
                  </Button>

                  <Button type='default' size='large' htmlType='button' onClick={this.props.onCancel}>
                    Cancel
                  </Button>
                </Form.Item>
              </Form>
          </div>
      );
    }
}

export default Form.create({ name: 'followUp90Day' })(MyProfileForm);



// WEBPACK FOOTER //
// ./src/components/MyProfileForm/MyProfileForm.js